import { Asset, Entry, UnresolvedLink } from "contentful";
import { ImgHTMLAttributes } from "react";

import MediaAsset from "~/components/common/media-asset";
import Editorials from "~/types/editorials";
import { isActiveAsset, isActiveEntry } from "~/utils/editorial-utils";

type Props = {
  entry?:
    | UnresolvedLink<"Entry">
    | Entry<Editorials.SingleAsset, undefined, string>;
  entryFallback?: UnresolvedLink<"Asset"> | Asset<undefined, string>;
  fill?: boolean;
  width?: number;
  height?: number;
  noLazy?: boolean;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, "placeholder">;

export default function SingleAsset({
  entry,
  entryFallback,
  fill,
  width,
  height,
  ...rest
}: Props) {
  if (entry && isActiveEntry(entry)) {
    const { asset, poster, autoPlay, controls, loop, muted, playsInline } =
      entry.fields;
    const videoConfig = { autoPlay, controls, loop, muted, playsInline };

    return (
      <MediaAsset
        entry={asset}
        poster={isActiveAsset(poster) ? poster?.fields?.file?.url : undefined}
        videoConfig={videoConfig}
        fill={fill}
        width={width}
        height={height}
        {...rest}
      />
    );
  } else if (entryFallback) {
    return (
      <MediaAsset
        entry={entryFallback}
        fill={fill}
        width={width}
        height={height}
        {...rest}
      />
    );
  }

  return null;
}
